import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetHasSearchEnabledQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetHasSearchEnabledQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, canUseNewQuickSearch?: boolean | null } | null };


export const GetHasSearchEnabled = /*#__PURE__*/ gql`
    query GetHasSearchEnabled($accountId: ID!) {
  account(accountId: $accountId) {
    id
    canUseNewQuickSearch
  }
}
    ` as unknown as DocumentNode<GetHasSearchEnabledQuery, GetHasSearchEnabledQueryVariables>;

          

          export const useGetHasSearchEnabledQuery = (options?:QueryHookOptions<GetHasSearchEnabledQuery, GetHasSearchEnabledQueryVariables>) => useQuery(GetHasSearchEnabled, options);

          

          export type GetHasSearchEnabledQueryOptions = QueryHookOptions<GetHasSearchEnabledQuery, GetHasSearchEnabledQueryVariables>;

          

          export const useGetHasSearchEnabledLazyQuery = (options?:LazyQueryHookOptions<GetHasSearchEnabledQuery, GetHasSearchEnabledQueryVariables>) => useLazyQuery(GetHasSearchEnabled, options);

          

          export type GetHasSearchEnabledQueryResult = ReturnType<typeof useGetHasSearchEnabledQuery>;

          
